<script>
    import { onDestroy, onMount } from "svelte";
    import { messaging } from "./store/messaging-store";

    export let bot;
    $: charId = bot.defaultChar.botId;
    let pcRreviewVisible = false;
    let mobile3DFrame, mobile2DFrame, pc3DFrame;

    let messagingSubsc;
    let timestamp = Date.now();
    let scenarioId = "";
    let pcViewPortClass = "frame1024";

    onMount(() => {
        messagingSubsc = messaging.subscribe((message) => {
            console.log("message: ", message);
            if (message.target !== "Preview") {
                return;
            }

            switch (message.action) {
                case "refreshPreview":
                    if (message.scenarioId) {
                        scenarioId = message.scenarioId;
                    }
                    refreshMobileFrame();
                    break;
                case "highlightBlock":
                    highlightPreviewBlock(message.buttonId);
                    break;
                case "refreshBlocks":
                    // 하드 리로드(iframe 재설정) 없이 프로필 앱에 블록 재조회만 요청 → 깜빡임/스크롤 튐 없음
                    refreshPreviewBlocks();
                    break;
                case "hubPreviewStage":
                    // 허브 빌더 [기본] 탭 단계별 멘트 — 그 단계(사전/메인/사후) 화면을 미리보기에 띄운다(null = 원래대로)
                    postHubPreviewStage(message.stage ?? null);
                    break;
            }
        });
    });

    onDestroy(() => {
        messagingSubsc();
    });

    const refreshMobileFrame = () => {
        timestamp = Date.now();
        mobile3DFrame.src += "";
    };

    const refreshPCFrame = () => {
        timestamp = Date.now();
        pc3DFrame.src += "";
    };

    // 빌더에서 블럭 선택 시, /view 창으로 메시지를 보낸다.
    // /view(View.svelte)의 relayHighlight가 받아서 내부 prd(React) iframe으로 한 번 더
    // 릴레이하고, 거기서 useBlockHighlight가 수신한다.
    // (외부에서 중첩 iframe을 querySelector로 직접 뚫는 방식은 타이밍·구조에 취약해 폐기)
    const postHighlight = (frame, buttonId) => {
        if (!frame?.contentWindow) {
            console.warn("[highlight] frame 없음");
            return;
        }
        frame.contentWindow.postMessage(
            { source: "avatalk-builder", type: "highlightBlock", buttonId },
            "*",
        );
        console.log("[highlight] /view로 postMessage 전송 buttonId=", buttonId);
    };

    const highlightPreviewBlock = (buttonId) => {
        console.log(
            "[highlight] highlightPreviewBlock 호출 buttonId=",
            buttonId,
        );
        if (!buttonId) return;
        postHighlight(mobile3DFrame, buttonId);
        if (pcRreviewVisible) postHighlight(pc3DFrame, buttonId);
    };

    // 하드 리로드 없이 프로필 앱(useEnterpriseData)에 블록 데이터 재조회를 요청한다.
    // highlightBlock과 동일하게 /view가 내부 React iframe으로 릴레이한다.
    const postRefreshBlocks = (frame) => {
        if (!frame?.contentWindow) return;
        frame.contentWindow.postMessage(
            { source: "avatalk-builder", type: "refreshBlocks" },
            "*",
        );
    };

    const refreshPreviewBlocks = () => {
        postRefreshBlocks(mobile3DFrame);
        if (pcRreviewVisible) postRefreshBlocks(pc3DFrame);
    };

    // 허브 미리보기 단계 고정. highlightBlock 과 같은 릴레이 경로(/view → 안쪽 프로필 앱, PROFILE usePreviewStage).
    // ⚠️ 저장 뒤 미리보기가 새로 고쳐져도 프로필 앱이 sessionStorage 로 기억해 같은 단계로 다시 뜬다.
    const postHubPreviewStage = (stage) => {
        for (const frame of [mobile3DFrame, pcRreviewVisible ? pc3DFrame : null]) {
            frame?.contentWindow?.postMessage({ source: "avatalk-builder", type: "hubPreviewStage", stage }, "*");
        }
    };
</script>

<div
    class="preview-wrap tw-flex tw-w-full tw-flex-col tw-items-center tw-px-4 tw-py-5 tw-font-sans"
>
    <!-- 컨트롤 행: 새로고침. 폰(preview-interface, 375px)과 같은 폭으로 가운데 정렬 →
         버튼 오른쪽 끝이 디바이스 오른쪽 끝 선과 맞는다. mb로 폰과의 세로 간격도 확보. -->
    <div
        class="tw-mb-3 tw-flex tw-w-full tw-max-w-[375px] tw-items-center tw-justify-end tw-gap-1"
    >
        <button
            type="button"
            class="tw-inline-flex tw-h-7 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-md tw-bg-muted tw-px-2.5 tw-text-xs tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-text-foreground"
            on:click={refreshMobileFrame}
            title="미리보기 화면을 다시 불러와요"
        >
            <svg
                class="tw-h-3.5 tw-w-3.5 tw-shrink-0"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                ><path
                    d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
                /><path d="M21 3v5h-5" /><path
                    d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
                /><path d="M8 16H3v5" /></svg
            >
            새로고침
        </button>
    </div>
    <div class="preview-interface">
        <div class="interface-wrap {bot.defaultChar.charId}">
            {#if charId}
                <iframe
                    id="mobile-frame"
                    bind:this={mobile3DFrame}
                    src="/view/{bot.defaultChar.botId}?mode=preview&charId={bot
                        .defaultChar
                        .charId}&last_value={scenarioId}&timestamp={timestamp}"
                />
            {/if}
        </div>
    </div>
    <!-- <div class="preview-guide tw-mt-4 tw-text-center">
        <div class="tw-text-sm tw-font-medium tw-text-muted-foreground">
            제작이 어려우신가요?
        </div>
        <div class="tw-mt-2 tw-flex tw-flex-col tw-items-center tw-gap-1.5 tw-text-sm">
            <a
                class="tw-text-primary hover:tw-underline"
                href="https://avatalk-1.gitbook.io/avatalk/undefined/undefined-1"
                target="_blank">아바톡 제작 가이드 보기!</a
            >
            <a
                class="tw-text-primary hover:tw-underline"
                href="https://www.youtube.com/watch?v=tRIEl1sVYYQ"
                target="_blank">아바톡 제작 영상 보기!</a
            >
        </div>
    </div> -->
</div>

<div
    class="pc-preview-popup pc-preview-interface {pcRreviewVisible
        ? 'show-flex-center'
        : 'hide'}"
>
    <div class="control-buttons button-group">
        <button
            class={pcViewPortClass === "frame720" ? "active" : ""}
            on:click={() => (pcViewPortClass = "frame720")}>720</button
        >
        <button
            class={pcViewPortClass === "frame1024" ? "active" : ""}
            on:click={() => (pcViewPortClass = "frame1024")}>1024</button
        >
        <button
            class={pcViewPortClass === "frame1280" ? "active" : ""}
            on:click={() => (pcViewPortClass = "frame1280")}>1280</button
        >
        <button
            class={pcViewPortClass === "frame1440" ? "active" : ""}
            on:click={() => (pcViewPortClass = "frame1440")}>1440</button
        >
    </div>
    <div class="control-buttons preview-specific-button">
        <button on:click={refreshPCFrame}>
            <img src="/static/images/Reload-icon.svg" loading="lazy" alt="" /> Reload
        </button>
        <button on:click={() => (pcRreviewVisible = false)}>
            <img src="/static/images/Close-icon.svg" loading="lazy" alt="" /> Closed
        </button>
    </div>
    <div class="popup-layer pc-preview {pcViewPortClass}">
        <div class="preview-interface pc">
            <div class="interface-wrap pc">
                {#if pcRreviewVisible && charId}
                    <iframe
                        id="pc-frame"
                        bind:this={pc3DFrame}
                        src="/view/{bot.defaultChar
                            .botId}?mode=preview&charId={bot.defaultChar
                            .charId}&last_value={scenarioId}&timestamp={timestamp}"
                    />
                {/if}
            </div>
        </div>
    </div>
</div>

<style>
    .hide {
        display: none !important;
    }

    .show-flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .control-buttons {
        position: fixed;
        top: 5px;
        right: 5px;
        z-index: 200;
    }
    .button-group {
        margin-right: 184px;
    }
    .preview-specific-button {
        margin-right: 2px;
        padding-right: 5px;
        width: 170px;
    }
    .preview-specific-button button {
        width: 80px;
    }

    .control-buttons > button {
        text-align: center;
        width: 82px;
        padding: 5px 0px;
        margin-left: -4px;
        border-left: 1px solid #ccc;
    }

    .control-buttons > button.active {
        color: #ffffff;
        background-color: #3e5c7e;
    }

    .control-buttons > button:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        margin-left: 0px;
        border-left: 0px;
    }

    .control-buttons > button:last-child {
        border-right: 0px solid transparent;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .popup-layer {
        transition:
            width 1s,
            height 1s;
    }

    .frame720 {
        width: 720px;
        height: 1000px;
    }

    .frame1024 {
        width: 1024px;
        height: 768px;
    }

    .frame1280 {
        width: 1280px;
        height: 800px;
    }

    .frame1440 {
        width: 1440px;
        height: 900px;
    }

    .popup-refresh {
        position: absolute;
        left: auto;
        top: 35px;
        right: -4%;
        bottom: auto;
        width: 26px;
        height: 26px;
        background-color: #e3e6ec;
        background-image: url(../images/refresh-icon.svg);
        background-position: 50% 50%;
        background-size: auto;
        background-repeat: no-repeat;
    }

    #mobile-frame {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }

    #pc-frame {
        position: absolute;
        top: -2px;
        left: -2px;
        right: 0px;
        height: calc(100% + 4px);
        width: calc(100% + 4px);
    }

    .popup-xbutton {
        cursor: pointer;
    }

    .pc-preview-popup {
        position: fixed !important;
    }

    .ava-watermark {
        background-size: 100px;
    }

    /* 프리뷰 캔버스: 카드(bg-card) 위에 폰이 놓이므로 배경은 비운다. 높이는 콘텐츠에 맞춘다
       (webflow의 height:100vh 무력화 → 카드 안에서 불필요한 빈 공간/스크롤 방지). */
    .preview-wrap {
        background: transparent;
        height: auto;
        min-height: 100%;
    }

    /* 디바이스: 일반적인 모바일 사이즈(375×812, iPhone 기준)로 재정의.
       기존 webflow 매직넘버(베젤 370×690 / 화면 350×670 / iframe 360×676 overhang)를 걷어내고
       화면=iframe이 프레임을 꽉 채우게 한다. 얇은 테두리+라운드+그림자로 깔끔한 폰 실루엣.
       좁은 화면에선 max-width:100% + aspect-ratio 로 비율 유지한 채 축소.
       .pc(오른쪽 PC 팝업)는 별도 규칙이라 :not(.pc) 로 모바일 프리뷰에만 적용. */
    .preview-interface:not(.pc) {
        width: 375px;
        max-width: 100%;
        aspect-ratio: 375 / 812;
        height: auto;
        flex-shrink: 0;
        padding: 0;
        border-radius: 40px;
        border: 1px solid hsl(var(--sb-border));
        background-color: hsl(var(--sb-card));
        box-shadow:
            0 22px 48px -20px rgba(0, 0, 0, 0.38),
            0 8px 20px -12px rgba(0, 0, 0, 0.22);
        overflow: hidden;
        position: relative;
    }
    .interface-wrap:not(.pc) {
        width: 100%;
        height: 100%;
        padding: 0;
        border-radius: 40px;
        overflow: hidden;
        background-color: hsl(var(--sb-card));
        box-shadow: none;
    }
    .popup-layer {
        margin: auto;
    }
</style>
